import api, { apiPrefix } from './Api';
import {
  Settings,
  settingsFromResponse,
} from '../interfaces/Settings/Settings';

const settingsApiPrefix = `${apiPrefix}/settings`;

export const getSettings = async (): Promise<Settings> => {
  const response = await api.get(settingsApiPrefix);

  return settingsFromResponse(response.data?.data);
};
